import { DashboardLateralNav } from 'components/DashboardLateralNav';
import { Navbar } from 'components/Navbar';
import { AdminReportProvider, CompaniesProvider, PartnerProvider } from 'context';
import { PartnersAdminProvider } from 'context/PartnersAdminContext';
import { RepresentativeProvider } from 'context/RepresentativeContext';
import { FC, useEffect, useState } from 'react';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { AssessmentOutlined, AssessmentRounded, AssignmentInd, SummarizeOutlined, SummarizeRounded } from '@mui/icons-material';
import BusinessIcon from '@mui/icons-material/Business';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import GroupIcon from '@mui/icons-material/Group';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import { Box, Container, Toolbar } from '@mui/material';

import Chart from '../../assets/icons/chart_data.svg';
import { Advertisement } from './Advertisement';
import { AdvertisementEdit } from './Advertisement/AdvertisementEdit';
import { AdvertisementSignUp } from './Advertisement/AdvertisementSignUp';
import { Company } from './Company';
import { CompanyCreateUpdate } from './Company/CompanyCreateUpdate';
import { CompanyView } from './Company/CompanyView';
import { Evaluation } from './Evaluation';
import { Partner } from './Partner';
import { PartnerCreateUpdate } from './Partner/PartnerCreateUpdate';
import { PartnerView } from './Partner/PartnerView';
import { Representative } from './Representative';
import { RepresentativeCreateUpdate } from './Representative/RepresentativeCreateUpdate';
import { RepresentativeView } from './Representative/RepresentativeView';
import { Tutor } from './Tutor';
import { Vet } from './Vet';
import { VetEdit } from './Vet/VetEdit';
import { VetSignUp } from './Vet/VetSignUp';
import { Voucher } from './Voucher';
import { VoucherCreate } from './Voucher/VoucherCreate';
import { VoucherEdit } from './Voucher/VoucherEdit';
import { Report } from './Report';
import { Dashboard } from './Dashboard';
import { DashboardByPlan } from './Dashboard/Treatment';

const MapRouteTitle = {
  '/vets': 'Veterinários',
  '/partners': 'Parceiros',
  '/advertisements': 'Anúncios',
  '/vouchers': 'Cupons',
  '/tutors': 'Tutores',
  '/companies': 'Empresas',
  '/evaluation': 'Gestão de Avaliações',
  '/representative': 'Gestão de Representantes',
  '/report': 'Gestão de Relatório',
  '/': 'Dashboard',
};

export const Admin: FC = () => {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const [items, setItems] = useState([{}]);
  const [openSideMenu, setOpenSideMenu] = useState(true);
  const [pageTitle, setPageTitle] = useState('Veterinários');
  const toggleDrawer = () => {
    setOpenSideMenu(!openSideMenu);
  };

  const getQueryTitle = () => {
    Object.entries(MapRouteTitle).forEach(([key, value]) => {
      if (pathname.search(key) >= 0) {
        setPageTitle(value);
      }
    });
  };

  useEffect(() => {
    getQueryTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    setItems([
      {
        name: 'Dashboard',
        url: `${path}/`,
        component: <AssessmentRounded />,
        route: '/',
      },
      {
        name: 'Veterinários',
        url: `${path}/vets`,
        component: <GroupIcon />,
        route: '/vets',
      },
      {
        name: 'Parceiros',
        url: `${path}/partners`,
        component: <BusinessIcon />,
        route: '/partners',
      },
      {
        name: 'Anúncios',
        url: `${path}/advertisements`,
        component: <MoveToInboxIcon />,
        route: '/advertisements',
      },
      {
        name: 'Cupons',
        url: `${path}/vouchers`,
        component: <LoyaltyIcon />,
        route: '/vouchers',
      },
      {
        name: 'Tutores',
        url: `${path}/tutors`,
        component: <AssignmentInd />,
        route: '/tutors',
      },
      {
        name: 'Empresas',
        url: `${path}/companies`,
        component: <BusinessCenterIcon />,
        route: '/companies',
      },
      {
        name: 'Avaliações',
        url: `${path}/evaluation`,
        component: <Box mx="2px" component="img" src={Chart} />,
        route: '/evaluation',
      },
      {
        name: 'Representantes',
        url: `${path}/representative`,
        component: <ConnectWithoutContactIcon />,
        route: '/representative',
      },
      {
        name: 'Relatórios',
        url: `${path}/report`,
        component: <SummarizeRounded />,
        route: '/report',
      },
    ]);
  }, [path]);

  return (
    <Box sx={{ display: 'flex' }}>
      <DashboardLateralNav
        openSideMenu={openSideMenu}
        toggleDrawer={toggleDrawer}
        items={items}
        setPageTitle={setPageTitle}
      />
      <Navbar
        openSideMenu={openSideMenu}
        toggleDrawer={toggleDrawer}
        pageTitle={pageTitle}
      />
      <Box
        component="main"
        sx={{
          // backgroundColor: '#efefef',
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />

        <PartnersAdminProvider>
          <CompaniesProvider>
            <RepresentativeProvider>
              <Container sx={{ py: 3 }}>
                <Switch>
                  <Route exact path={`${path}/vets`}>
                    <Vet />
                  </Route>
                  <Route path={`${path}/vets/add`}>
                    <VetSignUp />
                  </Route>
                  <Route path={`${path}/vets/edit`}>
                    <VetEdit />
                  </Route>

                  {/* Partners */}
                  <Route exact path={`${path}/partners`}>
                    <Partner />
                  </Route>

                  <Route exact path={`${path}/partners/view/:id`}>
                    <PartnerView />
                  </Route>

                  <Route path={`${path}/partners/add`}>
                    <PartnerCreateUpdate />
                  </Route>

                  <Route path={`${path}/partners/edit/:id`}>
                    <PartnerCreateUpdate />
                  </Route>

                  {/* Advertisements */}
                  <Route exact path={`${path}/advertisements`}>
                    <Advertisement />
                  </Route>
                  <Route path={`${path}/advertisements/add`}>
                    <PartnerProvider>
                      <AdvertisementSignUp />
                    </PartnerProvider>
                  </Route>
                  <Route path={`${path}/advertisements/edit`}>
                    <AdvertisementEdit />
                  </Route>
                  <Route exact path={`${path}/tutors`}>
                    <Tutor />
                  </Route>
                  <Route exact path={`${path}/vouchers`}>
                    <Voucher />
                  </Route>
                  <Route path={`${path}/vouchers/add`}>
                    <VoucherCreate />
                  </Route>
                  <Route path={`${path}/vouchers/edit`}>
                    <VoucherEdit />
                  </Route>

                  {/* Avaliações que tutor deu para o veterinário */}
                  <Route exact path={`${path}/evaluation`}>
                    <Evaluation />
                  </Route>

                  {/* Reresentative */}
                  <Route exact path={`${path}/representative`}>
                    <Representative />
                  </Route>
                  <Route path={`${path}/representative/edit/:representativeId`}>
                    <RepresentativeCreateUpdate />
                  </Route>
                  <Route exact path={`${path}/representative/add`}>
                    <RepresentativeCreateUpdate />
                  </Route>
                  <Route path={`${path}/representative/view/:representativeId`}>
                    <RepresentativeView />
                  </Route>

                  {/* Companies */}
                  <Route exact path={`${path}/companies`}>
                    <Company />
                  </Route>

                  <Route path={`${path}/companies/add`}>
                    <CompanyCreateUpdate />
                  </Route>

                  <Route path={`${path}/companies/edit/:id`}>
                    <CompanyCreateUpdate />
                  </Route>

                  <Route path={`${path}/companies/view/:id`}>
                    <CompanyView />
                  </Route>


                  {/* Report */}
                  <Route exact path={`${path}/report`}>
                    <AdminReportProvider>
                      <Report />
                    </AdminReportProvider>
                  </Route>
                  <Route exact path={`${path}/`}>
                      <Dashboard />
                  </Route>

                  <Route exact path={`${path}/byPlan`}>
                      <DashboardByPlan />
                  </Route>
                </Switch>
              </Container>
            </RepresentativeProvider>
          </CompaniesProvider>
        </PartnersAdminProvider>
      </Box>
    </Box>
  );
};
